import instance from './common';

const policyUrl = '/mbr_policies';

const getPolicies = (
  http = instance,
  options = {},
) => http.get(policyUrl, options);

export {
  getPolicies, // eslint-disable-line import/prefer-default-export
};
